import {useInputSearch} from '@/hooks/useInputSearch'
import {useMemo} from 'react'
import {useGetMedicalReportTypesByPatient} from '../queries/useGetMedicalReportTypesByPatient'

export const useReportTypesSearchableListByPatient = ({
    patientId,
    userId,
    enabled,
    limit = 10
}: {
    patientId: string
    userId: string
    enabled?: boolean
    limit?: number
}) => {
    const searchControls = useInputSearch()
    const query = useGetMedicalReportTypesByPatient(
        {
            patientId,
            userId,
            search: searchControls.searchValue,
            limit,
            page: 1
        },
        {enabled}
    )

    const reportTypes = useMemo(() => query.data?.pages.flatMap(page => page.data) ?? [], [query.data])

    return {
        ...query,
        ...searchControls,
        reportTypes
    }
}
